module.exports = __webpack_public_path__ + "img/sanwnaw-web.3af08cbe.jpeg";